export default __webpack_public_path__ + "static/media/matiascarvallo.73460bec.png";